// Mini App: кнопка «Назад» Telegram и цвета шапки вслед за темой портала.
import type { Router } from 'vue-router';

function toHex(color: string, fallback: string): string {
  const match = color.match(/(\d+)[,\s]+(\d+)[,\s]+(\d+)/);
  if (!match) return /^#[0-9a-f]{6}$/i.test(color.trim()) ? color.trim() : fallback;
  const hex = [1, 2, 3].map(i => Number(match[i]).toString(16).padStart(2, '0')).join('');
  return `#${hex}`;
}

export function installMiniApp(router: Router): void {
  // Как прежний плагин: работаем при любом загруженном SDK Telegram, без него sync() молча выходит.
  const goBack = () => { window.history.length > 1 ? router.back() : router.push('/'); };
  function sync() {
    const app = window.Telegram?.WebApp;
    if (!app) return;
    app.BackButton?.offClick(goBack);
    app.BackButton?.onClick(goBack);
    if (router.currentRoute.value.path === '/') app.BackButton?.hide();
    else app.BackButton?.show();
    // Без сохранённого выбора наследуем схему Telegram, чтобы миниаппа не слепила ночью.
    try {
      if (!localStorage.getItem('sst-theme') && app.colorScheme) {
        document.documentElement.dataset.theme = app.colorScheme;
        localStorage.setItem('sst-theme', app.colorScheme);
      }
    } catch { /* приватный режим */ }
    const style = getComputedStyle(document.querySelector('[data-appearance]') ?? document.documentElement);
    try {
      // Прежняя оболочка задаёт --paper/--page, экраны дизайна — --ff-card/--ff-bg.
      app.setHeaderColor?.(toHex(style.getPropertyValue('--paper') || style.getPropertyValue('--ff-card'), '#f4efe5'));
      app.setBackgroundColor?.(toHex(style.getPropertyValue('--page') || style.getPropertyValue('--ff-bg'), '#f8eec1'));
    } catch { /* старые клиенты */ }
  }
  router.afterEach(() => sync());
  sync();
  // SDK Telegram подгружается deferred-скриптом и может появиться позже плагина.
  window.addEventListener('load', () => sync(), { once: true });
  // Перекрашиваем шапку Telegram вслед за переключением темы.
  new MutationObserver(() => sync()).observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
}
